import React from 'react';

import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

export const TextWithLangLinks = ({
  textId,
  enLinkRouteId,
  frLinkRouteId,
  ...rest
}: ITextWithLangLinks) => {
  const { formatMessage } = useIntl();

  return (
    <span data-testid="text-with-lang-links" {...rest}>
      {formatMessage(
        { id: textId },
        {
          enLink: (
            <Link to={formatMessage({ id: enLinkRouteId })}>{formatMessage({ id: 'en' })}</Link>
          ),
          frLink: (
            <Link to={formatMessage({ id: frLinkRouteId })}>{formatMessage({ id: 'fr' })}</Link>
          ),
        }
      )}
    </span>
  );
};
